
export const LS_SIDEBAR_MENU_STATE = 'sidebarMenuState'

export const LS_NOTES_RELATIVE_DATE_OPTION = 'notesRelativeDate'
export const LS_NOTES_START_DATE = 'notesStartDate'
export const LS_NOTES_END_DATE = 'notesEndDate'

export const DEFAULT_PERMISSION_MESSAGE = 'You do not have permission to perform this action.'
export const GENERIC_UNKNOWN_ERROR_MESSAGE = 'Unknown error occurred. Please try again.'
export const DEFAULT_SESSION_EXPIRED_MESSAGE = 'Session expired. Please login again.'
export const MFA_LOGIN_SETTINGS_MESSAGE = 'Updating your login settings requires 2FA.'

export const MOBILE_GRID_WIDTH = 950
export const MAX_FILE_SIZE = 10485760 // 10MB

export const ALLOWED_IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.pjpeg', '.png', '.gif']
export const ALLOWED_EXCEL_EXTENSIONS = ['.csv', '.xls', '.xlsx']
export const ALLOWED_YOUTUBE_EXTENSIONS = ['.mov', '.mp4', '.avi', '.wmv', '.flv', '.3gp', '.mpeg', '.mkv', '.webm', '.m4v']
export const ALLOWED_TEXT_EXTENSIONS = ['.txt', '.doc', '.docx']
export const ALLOWED_PDF_EXTENSIONS = ['.pdf']

export const LS_CONTACT_HISTORY_RELATIVE_DATE_OPTION = 'contactHistoryRelativeDate'
export const LS_CONTACT_HISTORY_START_DATE = 'contactHistoryStartDate'
export const LS_CONTACT_HISTORY_END_DATE = 'contactHistoryEndDate'
export const LS_CONTACT_HISTORY_PAGE_SIZE = 'contactHistoryPageSize'
export const LS_CONTACT_HISTORY_SEARCH = 'contactHistorySearch'
export const LS_CONTACT_HISTORY_SELECTED_PAGE = 'contactHistorySelectedPage'
export const LS_CONTACT_HISTORY_SORT = 'contactHistorySort'

export const SALES_ROLE_ID = 3
export const CUSTOMER_SERVICE_USER_ID = 295

export const LS_SYNC_QUEUE_HISTORY_PAGE_SIZE = 'syncQueueHistoryPageSize'
export const LS_SYNC_QUEUE_HISTORY_SEARCH = 'syncQueueHistorySearch'
export const LS_SYNC_QUEUE_HISTORY_SELECTED_PAGE = 'syncQueueHistorySelectedPage'
export const LS_SYNC_QUEUE_HISTORY_SORT = 'syncQueueHistorySort'

export const LS_MIGRATION_DEALS_PAGE_SIZE = 'migrationDealsPageSize'
export const LS_MIGRATION_DEALS_SEARCH = 'migrationDealsSearch'
export const LS_MIGRATION_DEALS_SELECTED_PAGE = 'migrationDealsSelectedPage'
export const LS_MIGRATION_DEALS_SORT = 'migrationDealsSort'

export const LS_MIGRATION_QUEUE_HISTORY_PAGE_SIZE = 'migrationQueueHistoryPageSize'
export const LS_MIGRATION_QUEUE_HISTORY_SEARCH = 'migrationQueueHistorySearch'
export const LS_MIGRATION_QUEUE_HISTORY_SELECTED_PAGE = 'migrationQueueHistorySelectedPage'
export const LS_MIGRATION_QUEUE_HISTORY_SORT = 'migrationQueueHistorySort'